import { render } from "./chat_new.vue?vue&type=template&id=3553d6fa"
import script from "./chat_new.js?vue&type=script&lang=js"
export * from "./chat_new.js?vue&type=script&lang=js"

import "./chat_new.vue?vue&type=style&index=0&id=3553d6fa&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__